var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playbooks-recommendations"},[_vm._l((_vm.cards),function(card){return [(_vm.isRecommendation(card.cardType))?_c('playbooks-recommendation',{key:card.id,attrs:{"recommendation":card}}):_c('playbooks-upsell',{key:card.slug,staticClass:"container",attrs:{"upsell":card}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }